import { AutocompleteInput, ReferenceInput, required, SelectInput } from "react-admin";
import { Grid, Typography } from "@mui/material";
import ProfessorInput from "server/components/Fields/ProfessorInput";
import { specialistRequests } from "api/specialistApi";
import { useFormContext, useWatch } from "react-hook-form";
import { SpecializationTypes } from "utils/constants";

const SpecializationInfo = ({ isClinical, specializationInfo }) => {
  const isDisabled = !!specializationInfo?.specializationId;
  const specializationId = useWatch({ name: "specializationId" });
  const { setValue } = useFormContext();

  const handleSpecializationChange = () => {
    setValue("receptionTypeId", null);
    setValue("trainingBuildingId", null);
  };

  return (
    <>
      <Grid
        item
        xs={12}
      >
        <Typography
          color="primary"
          sx={{ mt: 2 }}
        >
          Специалност
        </Typography>
      </Grid>

      <>
        <Grid
          item
          xs={12}
          md={3}
        >
          <ReferenceInput
            source="specializationId"
            reference={specialistRequests.getSpecializationsSelect()}
            filter={{ type: isClinical ? SpecializationTypes.Clinical : SpecializationTypes.NonClinical }}
          >
            <AutocompleteInput
              optionText="nameBg"
              label="Специалност"
              fullWidth
              readOnly={isDisabled}
              validate={[required()]}
              filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
              onChange={handleSpecializationChange}
            />
          </ReferenceInput>
        </Grid>
        {specializationId && (
          <Grid
            item
            xs={12}
            md={3}
          >
            <ReferenceInput
              source="receptionTypeId"
              reference={specialistRequests.getSpecialistReceptionTypesSelect(specializationId)}
            >
              <SelectInput
                optionText="nameBg"
                label="Вид прием"
                validate={[required()]}
                readOnly={isDisabled}
                fullWidth
              />
            </ReferenceInput>
          </Grid>
        )}
      </>
      {specializationId && (
        <Grid
          item
          xs={12}
          md={3}
        >
          <ReferenceInput
            source="trainingBuildingId"
            reference={specialistRequests.getTrainingBuildingsSelect()}
            filter={{ SpecializationId: specializationId }}
          >
            <AutocompleteInput
              label="База за обучение"
              optionText="buildingNameBg"
              readOnly={isDisabled}
              fullWidth
              filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            />
          </ReferenceInput>
        </Grid>
      )}

      <Grid
        item
        xs={12}
        md={3}
      >
        <ProfessorInput
          source="supervisorEmployeeId"
          label="Ръководител"
          validate={!isClinical ? required() : undefined}
        />
      </Grid>
    </>
  );
};

export default SpecializationInfo;
